import { wealthProApi } from "../../redux/api";

const graphCalendarEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ['graphCalendars']
}).injectEndpoints({
    endpoints: ((builder) => ({
        fetchCalendarsList: builder.query({
            query: ({ userId }: { userId: string | null }) => ({
                url: userId ? `api/graph/graph/${userId}/calendars` : `api/graph/me/calendars`,
            })
        })
    }))
});

export const {
    useFetchCalendarsListQuery,
    useLazyFetchCalendarsListQuery
} = graphCalendarEndpoints;